module.exports = "<she-navbar></she-navbar>\n\n<div class=\"page-content-wrapper\">\n  <div class=\"page-content\">\n    <router-outlet></router-outlet>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/app-admin.component.html
// module id = 592
// module chunks = 8